import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { TabsTimeline, FormFooter } from 'components';
import { isNil, isEmpty } from 'lodash';
import { stepsBeneficiary } from './stepsBeneficiary';
import { fetchProcInstancesDetailed, getApptrackDetails, getDetails, setApptrackLoading } from 'store/appTrack/actions';
import { clearForm, getSystemLocales } from 'store/forms/actions';
import { checkUser, getUser } from 'store/user/actions';
import { useNavigate } from 'react-router-dom';
import { isBeneficiary } from 'utils';
import { Spin } from 'antd';

const ViewForm = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [current, setCurrent] = useState(0);
  const currentSubTab = useSelector(state => state.forms.carrier.currentSubTab);
  const user = useSelector(state => state.user);

  const privileges = useSelector(state => state.user.privileges);
  const [activeTask, setActiveTask] = useState('');
  const url = window.location.pathname;
  const id = url.substring(url.lastIndexOf('/') + 1);

  const isApptrack = url.includes('apptrack');
  
  const variables = useSelector(state => state.appTrack.variables);

  // const apptrackDetails = useSelector(state => state?.appTrack?.apptrackDetails);
  const activeForm = useSelector(state=> state.activeForm.activeFormId);
  const pageLoading = useSelector(state=> state.appTrack.loading);

  useEffect(()=>{
    dispatch(setApptrackLoading());
  },[activeForm])

  useEffect(()=>{
    if(!isEmpty(variables)) {
      setActiveTask(variables?.find(item => item.id === id));
    } else {
      const storedLanguage = localStorage.getItem('appLanguage') || process.env.REACT_APP_DEFAULT_APP_LANGUAGE;
      dispatch(getSystemLocales(storedLanguage));
      dispatch(checkUser(navigate));
      dispatch(getUser());
      dispatch(clearForm());
      dispatch(fetchProcInstancesDetailed());
    }
  },[variables])

  useEffect(()=>{
    if(activeTask){
      dispatch(getApptrackDetails(activeTask.id));
    }
  },[activeTask])


  return (
    pageLoading ?
    <div
      style={{
        position:"absolute",
        left:"50%",
        top:"50%"
      }}
    >
      <Spin size="large" />
    </div> 
    :
    <div id="mainforms-page-1" className="investor-form-container">
     {!isNil(current) && 
     <div className="investor-steps-footer-container">
      <TabsTimeline 
          tabs={stepsBeneficiary} 
          current={current} 
          setCurrent={setCurrent} 
          customClass={'custom-tabs-timeline'}
          activeTask={activeTask}
          isApptrack={isApptrack}
      />
      <FormFooter 
        tabs={stepsBeneficiary}
        current={current} 
        setCurrent={setCurrent} 
        currentSubTab={currentSubTab} />
      </div>
      }
    </div>
  );
};

export default ViewForm;
